import { brandPrimaryHover, header, warningDark } from '@Styles/colors';
import { CssSelectors } from '@Styles/styles';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';

const { spacing, colors } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		padding: 16,
	},
	tabViewTabs: {
		display: 'flex',
		borderBottom: '1px solid #e2e8f0',
	},
	tabViewItem: {
		borderBottom: `1px solid #D3DBDE `,
		color: header,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: 14,
		height: 44,
		padding: '0 36px',
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		alignItems: 'center',
	},
	section: {
		padding: 16,
	},
	header: {
		display: 'flex',
		gap: 16,
		alignItems: 'center',
		justifyContent: 'flex-end',
		marginBottom: 16,
		width: '100%',
	},
	noResults: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 16,
	},
	tableContainer: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '80%',
	},
	loadingRow: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
	},
	tableOverrides: {
		width: '100%',
		tableLayout: 'fixed',
	},
	statusIndicator: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				height: 20,
				margin: '0 10px 0 -30px',
				width: 20,
			},
			'span'
		),
	},
	statusIndicatorActive: {
		marginRight: 10,
	},
	statusIndicatorInactive: {
		opacity: 0.5,
	},
	etlStagesContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		padding: 20,
	},
	confirmationDialogDescription: {
		fontSize: 14,
		color: '#333',
		marginBottom: spacing.sm,
		textAlign: 'center',
		maxWidth: 600,
	},
	icons: {
		height: 17,
		width: 17,
		marginLeft: spacing.sm,
		display: 'inline-block',
		verticalAlign: 'middle',
	},
	copyButton: {
		alignItems: 'center',
		display: 'flex',
		gap: 5,
	},
	filterContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: 10,
		alignItems: 'center',
		marginBottom: spacing.md,
	},
	selectContainer: {
		width: 200,
	},
	clearSearch: {
		background: 'transparent',
		border: 'none',
		color: brandPrimaryHover,
		cursor: 'pointer',
		fontSize: 14,
		fontWeight: 500,
		padding: '8px 12px',
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},
	emptyState: {
		color: '#666',
		fontSize: 14,
	},
	popoverContent: {
		padding: spacing.md,
		minWidth: 'auto',
	},
	dateRangeContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.md,
	},
	presetButtons: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	calendarContainer: {
		display: 'flex',
		justifyContent: 'center',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: spacing.xs,
		marginTop: spacing.md,
		paddingTop: spacing.md,
		borderTop: '1px solid #e2e8f0',
	},
	setupIndicator: {
		width: 8,
		height: 8,
		borderRadius: '50%',
		backgroundColor: warningDark,
		marginLeft: spacing.xs,
		display: 'inline-block',
		verticalAlign: 'middle',
	},
	setupRequiredBanner: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		padding: `${spacing.sm}px ${spacing.md}px`,
		backgroundColor: colors.warning.light,
		borderRadius: 6,
		marginBottom: spacing.md,
		border: `1px solid ${warningDark}`,
	},
	setupRequiredIcon: {
		width: 20,
		height: 20,
		flexShrink: 0,
	},
	setupRequiredText: {
		fontSize: 14,
		color: warningDark,
	},
	setupRequiredLink: {
		color: warningDark,
		fontWeight: 600,
		textDecoration: 'underline',
		cursor: 'pointer',
		':hover': {
			textDecoration: 'none',
		},
	},
});
